import React, { useState } from 'react';
import { API_BASE } from '../config';

export default function BugReport({ onClose }) {
  const [title, setTitle] = useState('');
  const [text, setText] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async () => {
    if (text.trim().length < 10) return;
    try {
      const sess = localStorage.getItem('session');
      let guildId = localStorage.getItem('active_room') || 'global';
      if (guildId === 'global' && sess) {
        try { const p = sess.split('.')[1]; guildId = JSON.parse(atob(p + '='.repeat((4-p.length%4)%4))).guild_id || 'global'; } catch(e) {}
      }
      await fetch(`${API_BASE}/state/${guildId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('session')}` },
        body: JSON.stringify({ action: 'submit_bug', title: title.trim() || 'Bug Report', description: text.trim() })
      });
    } catch (e) { /* still show success */ }
    setSubmitted(true);
    setTimeout(onClose, 1500);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-card" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>🪲 Report a Bug</h2>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>
        <div className="modal-body">
          {submitted ? (
            <div style={{ textAlign: 'center', padding: '20px' }}>
              <div style={{ fontSize: '2rem', marginBottom: '12px' }}>✅</div>
              <p style={{ color: 'var(--text)' }}>Bug reported. Thank you!</p>
            </div>
          ) : (
            <>
              <p style={{ fontSize: '0.7rem', color: 'var(--text-dim)', marginBottom: '12px' }}>Describe what went wrong. Be as specific as possible.</p>
              <input
                className="campaign-textarea"
                value={title}
                onChange={e => setTitle(e.target.value)}
                placeholder="Short title (e.g. Fire Shield won't expire)"
                style={{ marginBottom: '8px', padding: '8px', width: '100%', boxSizing: 'border-box' }}
              />
              <textarea
                className="campaign-textarea"
                value={text}
                onChange={e => setText(e.target.value)}
                placeholder="What happened? What did you expect to happen?"
                rows={5}
              />
              {text.trim().length > 0 && text.trim().length < 10 && (
                <p style={{ fontSize: '0.6rem', color: '#e74c3c', marginTop: '6px' }}>Please write at least 10 characters.</p>
              )}
            </>
          )}
        </div>
        {!submitted && (
          <div className="modal-footer">
            <button className="btn-primary" onClick={handleSubmit} disabled={text.trim().length < 10}>Submit Report</button>
          </div>
        )}
      </div>
    </div>
  );
}
